// extracted by mini-css-extract-plugin
export default {"wrp":"DeletingLine_wrp__jE6Fl","title":"DeletingLine_title__OiHgW","btns":"DeletingLine_btns__9TcG8","button":"DeletingLine_button__qXd8y"};